/**
 * The `showTooltip` util returns a status value to display the tooltip.
 */
export const showTooltip = (
    element: HTMLElement | null | undefined,
    title?: string,
): boolean => {
    if (element && element instanceof HTMLElement) {
        if (element.offsetWidth < element.scrollWidth) {
            element.setAttribute('title', title || element.innerText);
            return true;
        } else {
            element.removeAttribute('title');
            return false;
        }
    }

    return false;
};
